import React, { useEffect, useState } from "react";
import "./leftSidebar2.css";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { RxCaretDown, RxCaretUp } from "react-icons/rx";
import { Link, useLocation } from "react-router-dom";
import { sidebarItems } from "../constants/SidebarConstants";
import { filterSidebarItemsByRole } from "../utils/modulePermissions";
import { API_END_POINT } from "../config/apiEndPoint";
import useAuth from "../hooks/useAuth";
import Select from "react-select";

import gridView from "../assets/images/grid_view.svg";
import glocalIcon from "../assets/images/glocal_icon.svg";
import bamIcon from "../assets/images/bam_icon.svg";
import contentxIcon from "../assets/images/contentx_icon.svg";
import geobizIcon from "../assets/images/geobiz_icon.svg";
import mintIcon from "../assets/images/mint_icon.svg";
import salesconnectIcon from "../assets/images/salesconnect_icon.svg";
import trendvizorIcon from "../assets/images/trendvizor_icon.svg";
import axios from "axios";
import { ROOT_URL, switchApiEndPoint } from "../config/constant";

const getUserModules = (userData) => {
  const modules = new Set();

  let clients = [];

  try {
    if (userData["custom:clients"]) {
      clients = JSON.parse(userData["custom:clients"]);
    }
  } catch (err) {
    console.error("Failed to parse user clients:", err);
  }

  clients.forEach((client) => {
    if (Array.isArray(client.services)) {
      client.services.forEach((service) => {
        if (service.active && service.value) {
          modules.add(service.value);
        }
      });
    }
  });

  return modules;
};

const filterSidebarItems = (userData, sidebarItems) => {
  const userModules = getUserModules(userData);
  return sidebarItems.filter((item) => userModules.has(item.id));
};

const LeftSidebar2 = ({
  toggleSidebar,
  setToggleSidebar,
  setCreationRandomId,
}) => {
  const [expandedMenus, setExpandedMenus] = useState({});
  const [sidebarMenu, setSidebarMenu] = useState(sidebarItems);
  const [services, setServices] = useState([]);

  const { isLoggedin, user } = useAuth();

  const location = useLocation();

  const [activeSubItem, setActiveSubItem] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (isLoggedin && user) {
      const filteredSidebarItems = filterSidebarItemsByRole(user, sidebarItems);
      setSidebarMenu(filteredSidebarItems);
    }
  }, [isLoggedin, user]);
  
   useEffect(() => {
    !toggleSidebar && setMenuOpen(false);
  }, [toggleSidebar]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
          Token_payload: JSON.stringify({
            userRole: "head_office",
            id_token: sessionStorage.getItem("token"),
          }),
        };
        // let account_name = ""; 
        // try{
        //   let decodedData = sessionStorage.getItem("decodedData");
        //   decodedData = JSON.parse(decodedData);
        //   account_name = JSON.parse(decodedData["custom:clients"])[0].account_name;
        // }catch(e){
        //   console.log("error is ========", e)
        // }
        const response = await axios.get(
          switchApiEndPoint,
          {
            headers,
          }
        );

        const paramClient = new URLSearchParams(sessionStorage.getItem("hash")).get("client")?.toLowerCase();
        const clientObj = response.data?.data?.clients?.find(
          acc => acc.account_name?.toLowerCase() === paramClient
        );
        const serviceList = clientObj?.accServices || [];

        let clients = [];
        try {
          const decodedData = JSON.parse(sessionStorage.getItem("decodedData"));
          clients = JSON.parse(decodedData["custom:clients"] || "[]");
          const activeServices = clients.flatMap(acc =>
            (acc.services ?? []).filter(service => service.active)
          ).map(item => item.value.toLowerCase());
          const filteredArray = serviceList.filter(item => decodedData["custom:userRole"].toLowerCase() == "superadmin" ? true : activeServices.includes(item.value.toLowerCase()));

          setServices([{ label: "GLOCAL", value: "glocal", role: user?.role || "", active: true, url: ROOT_URL }, ...filteredArray]);
        } catch (e) {
          setServices([{ label: "GLOCAL", value: "glocal", role: user?.role || "", active: true, url: ROOT_URL }, ...serviceList]);

          console.log("error is -", e);
        }

      } catch (error) {
        console.error("Failed to fetch accServices:", error);
      }
    };

    fetchServices();
  }, []);

  const handleEnterSidebarToggle = () => setToggleSidebar(true);
  const handleExitSidebarToggle = () => setToggleSidebar(false);
  const handleSubItemClick = (subItem) => {
    setCreationRandomId(
      Date.now() * 1000000 + Math.floor(Math.random() * 1000000)
    );
    setActiveSubItem(subItem);
  };

  const handleMenuToggle = (menuId) => {
    setExpandedMenus((prevState) => ({
      ...prevState,
      [menuId]: !prevState[menuId],
    }));
  };

  // const emojisWithImages = [
  //   { value: 'Glocal Home', label: 'Glocal Home', image: gridView },
  //   { value: 'Glocal Home', label: 'Glocal Home', image: glocalIcon },
  //   { value: 'BAM', label: 'BAM', image: bamIcon },
  //   { value: 'ContentX', label: 'ContentX', image: contentxIcon },
  //   { value: 'Geobiz', label: 'Geobiz', image: geobizIcon },
  //   { value: 'Mint360', label: 'Mint360', image: mintIcon },
  //   { value: 'SalesConnect', label: 'SalesConnect', image: salesconnectIcon },
  //   { value: 'TrendVizor', label: 'TrendVizor', image: trendvizorIcon },
  // ];

  const iconMap = {
    "glocal": glocalIcon,
    bam: bamIcon,
    contentx: contentxIcon,
    GeoBiz: geobizIcon,
    Mint360: mintIcon,
    SalesConnect: salesconnectIcon,
    trend_vizor: trendvizorIcon,
  };

  const emojisWithImages = services
    .filter((service) => service.active)
    .map((service) => {
      return ({
        label: service.label,
        value: service.value,
        url: service.url,
        image: iconMap[service.value] || "/assets/icons/default.svg",
      })
    });

  const handleAppSwitch = (selectedOption) => {
    const selectedService = services.find(
      (service) => service.value === selectedOption.value && service.active
    );

    if (selectedService) {
      let hash = sessionStorage.getItem("hash") || "";
      let fullUrl = `${selectedService.url}${selectedService.url.endsWith('/') ? "#" : "/#"}${hash}`;

      if (!/^https?:\/\//i.test(fullUrl)) {
        fullUrl = `https://${fullUrl}`;
      }

      window.location.href = fullUrl;
    } else {
      alert("This application is not accessible right now.");
    }
  };

  const customSingleValue = ({ data }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img src={data.image} alt="" style={{ width: 18, marginRight: 8 }} />
      {data.label}
    </div>
  );
  const customPlaceholder = (props) => (
    <div style={{ display: "flex", alignItems: "center", color: "#6c757d" }}>
      <img
        src={gridView} // or any default image icon you want
        alt="platform"
        style={{ width: 18, height: 18, marginRight: 8 }}
      />
      {props.children}
    </div>
  );
  const customOption = (props) => {
    const { data, innerRef, innerProps, isFocused, selectProps } = props;
    const isLast = selectProps.options[selectProps.options.length - 1].value === data.value;
    return (
      <div>
        <div
          ref={innerRef}
          {...innerProps}
          style={{
            display: "flex",
            alignItems: "center",
            padding: 8,
            cursor: "pointer",
            backgroundColor: isFocused ? "#f7f7f7" : "transparent",
          }}
        >
          <img
            src={data.image}
            alt={data.label}
            style={{ width: 20, height: 20, marginRight: 8 }}
          />
          {data.label}
        </div>
        {!isLast && ( <hr className="my-1 ml-[10px] mr-[10px] border-t border-gray-200 border-0" /> )}
      </div>
    );
  };
  const handleToggleMenu = () => {
    setMenuOpen((prevState) => !prevState);
  };
  return (
    <div
      className="sidebar bg-blue"
      id={toggleSidebar ? "toggle" : "remove-toggle"}
      onMouseEnter={handleEnterSidebarToggle}
      onMouseLeave={handleExitSidebarToggle}
    >
      <div className="sidebar-toggle">
        <button>
          {toggleSidebar ? <IoIosArrowBack /> : <IoIosArrowForward />}
        </button>
      </div>

      <div className="sidebar-icons">
        <div className="sidebar_select">
          <div onClick={handleToggleMenu}>
            <Select
              options={emojisWithImages}
              onChange={handleAppSwitch}
              placeholder="Switch Platforms"
              components={{
                SingleValue: customSingleValue,
                Option: customOption,
                Placeholder: customPlaceholder,
              }}
              menuIsOpen={menuOpen}
              styles={{
                control: (base) => ({
                  ...base,
                  backgroundColor: "#FFF",
                  borderRadius: 4,
                  fontSize: 14,
                  padding: 4,
                  cursor: "pointer"
                }),
              }}
            />
          </div>
        </div>
        <ul className="icons">
          {/* <li className="sidebar-link logoRow">
            <a className={`${toggleSidebar ? "show" : ""}`} href="/" data-discover="true">
              <div
                className={`sidebar-link-icon  ${toggleSidebar ? "hide" : "show"} `}
              >
                <img src={bamSLogo} alt="logo" />
              </div>
              <span className={`No-Wrap bamLogo ${toggleSidebar ? "show" : ""}`}>
                <img src={bamLogo} alt="logo" />
              </span>
            </a>
          </li> */}
          {sidebarMenu.map((item) => {
            const isActive =
              location.pathname === item.link ||
              location.pathname.includes(item.link);
            return (
              <li
                key={item.id}
                className={` ${item.prodIcon ? "hover:bg-transparent" : ""
                  } sidebar-link ${isActive ? "active" : ""}`}
              >
                <Link
                  onClick={() => handleMenuToggle(item.id)}
                  to={item.subItems ? item.subItems[0].link : item.link}
                  className={`${toggleSidebar ? "show" : ""} ${item.prodIcon ? "hover:bg-transparent" : ""
                    }`}
                >
                  <div
                    className={`sidebar-link-icon  ${item.prodIcon ? "hover:bg-transparent" : ""
                      } ${isActive ? "active" : ""}`}
                  >
                    {item.icon}
                  </div>
                  <span className={`No-Wrap ${toggleSidebar ? "show" : ""}`}>
                    <button
                      className={`sidebar-link-btn ${item.prodIcon ? "hover:bg-transparent" : ""
                        } ${isActive ? "active" : ""}`}
                      type="button"
                    >
                      {item.title}
                    </button>
                    {item.subItems &&
                      (expandedMenus[item.id] ? (
                        <RxCaretUp />
                      ) : (
                        <RxCaretDown />
                      ))}
                  </span>
                </Link>

                {item.subItems && expandedMenus[item.id] && (
                  <ul className="submenu">
                    {item.subItems.map((subItem, index) => {
                      const isSubActive = location.pathname === subItem.link;
                      return (
                        <li key={index} className={isSubActive ? "active" : ""}>
                          <Link
                            to={subItem.link}
                            onClick={() => handleSubItemClick(subItem.title)}
                          >
                            <span
                              className={`${isSubActive ? "active" : ""
                                } sub-icon`}
                            >
                              {subItem.icon}
                            </span>
                            <p>{subItem.title}</p>
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default LeftSidebar2;
